import _ from "lodash";
import React, { useState } from "react";
import { Modal } from "@toddle-edu/ds-web";
import classes from "./EditChannelTab.scss";
import EditChannelComp from "MessagingV2/components/Channels/EditChannel/components";
import { CHAT_TYPE_ENUM } from "MessagingV2/modules/Utils";

const styles = {
  modalBody: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    paddingTop: "16px",
    overflowY: "auto",
  },
  modalFooter: {
    padding: "12px 16px",
  },
};

const EditChannelTab = props => {
  const {
    onCloseModal,
    chatId,
    channelLabel,
    channelDescription,
    channelProfileImage,
    channelType,
    channelBannerMessage,
  } = props;

  const [isUploading, setIsUploading] = useState(false);

  const showChannelProfileImage = _.includes(
    [CHAT_TYPE_ENUM.CHANNEL_PUBLIC, CHAT_TYPE_ENUM.CHANNEL_CUSTOM],
    channelType
  );

  const isDepartmentChannel = _.isEqual(
    channelType,
    CHAT_TYPE_ENUM.CHANNEL_DEPARTMENT
  );

  return (
    <EditChannelComp
      chatId={chatId}
      onClose={onCloseModal}
      channelLabel={channelLabel}
      channelDescription={channelDescription}
      channelProfileImage={channelProfileImage}
      channelBannerMessage={channelBannerMessage}
      isDepartmentChannel={isDepartmentChannel}
    >
      <Modal.Body style={styles.modalBody}>
        {showChannelProfileImage ? (
          <div className={classes.profileImageContainer}>
            <EditChannelComp.ProfileImage uploadStatus={setIsUploading} />
          </div>
        ) : null}
        <EditChannelComp.Name />
        {isDepartmentChannel ? (
          <EditChannelComp.BannerMessage />
        ) : (
          <EditChannelComp.Description />
        )}
      </Modal.Body>
      <Modal.Footer style={styles.modalFooter} hasSeparator>
        <EditChannelComp.Submit
          onClose={onCloseModal}
          isUploading={isUploading}
        />
      </Modal.Footer>
    </EditChannelComp>
  );
};

export default EditChannelTab;
